import React from 'react';
import styles from './index.module.less';
import Image from 'next/image';
import classNames from 'classnames';
import { useRouter } from 'next/router';
import { Button } from 'antd';

interface CardData {
  title?: string;
  desc?: string;
  svg?: string;
  imgPath?: string;
  btnText?: string;
  btnLink?: string;
  link?: string;
}

interface SectionData {
  title?: string;
  desc?: string;
  cards?: CardData[];
  imgPath?: string;
}

const KeyFeatures = ({ data, type }: { data?: SectionData; type: '1' | '2' }) => {
  const router = useRouter();

  const getContent = () => {
    if (!data) return null;
    return (
      <section className={styles.content}>
        {data?.title && <h2 className={styles.title}>{data?.title}</h2>}
        {data?.desc && <p className={styles.desc}>{data?.desc}</p>}
        <div className={styles.contentList}>
          {data?.cards?.length > 0 &&
            data?.cards?.map((item, index) => (
              <div className={styles.contentItem} key={index}>
                <div className={styles.contentItemTopContainer}>
                  <div className={classNames(styles.contentItemTitle)}>
                    <Image src={item.svg} alt={''} width={28} height={28} />
                    <h3 className={styles.subTitle}>{item.title}</h3>
                  </div>
                  <p className={styles.subDesc}>{item.desc}</p>
                </div>

                {item?.btnText && type == '1' && (
                  <div className="mt-5">
                    <Button
                      className={styles.linkContainer}
                      onClick={() => {
                        item?.btnLink && router?.push(item?.btnLink);
                      }}
                      prefix={'dfas'}
                    >
                      {item?.btnText}
                      <Image src={'/images/landingpage/arrow-icon1.webp'} alt={''} width={24} height={24} />
                    </Button>
                  </div>
                )}
              </div>
            ))}
        </div>
      </section>
    );
  };

  return <>{getContent()}</>;
};

export default KeyFeatures;
